if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        document.querySelector('.tw-pdp-zoom-trigger').addEventListener('click', function() {
          document.querySelector('.gallery-viewer ul .is-active button').click();
        })
      }

      static get observedAttributes() {
        return ['data-reset'];
      }
    
      /*
       * Currently used for pdp.
       * When the variant is changed, in addition to updating the "slider-component", the "media-gallery" is also updated.
       * This is to set the first visible thumbnail as active.
      */
      attributeChangedCallback(name, oldValue, newValue) {
       //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
        
        if (oldValue == "false") {
          // When changing the variant, the "aria-current" attribute is removed
          // Excluding default elements (no color in the image src)
          this.elements.thumbnails.querySelectorAll('ul li:not(.thumbnail-list__item--default) button').forEach((element) => element.removeAttribute('aria-current'));

          /**
           * All elements that have been added by the script tag (see "slider-component"),
           * are selected and the event is added to the new elements.
           */
          let thumbnailsToUpdate = this.elements.thumbnails.querySelectorAll('.js-media-gallery-update');
          if (thumbnailsToUpdate.length > 0) {
            thumbnailsToUpdate.forEach((media, index) => {
              media.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, media.dataset.target, false));
              
              if (index == 0) {
                media.querySelector('button').setAttribute('aria-current', true);
              }
              media.classList.remove('js-media-gallery-update')
            });
          } else {
            /**
             * If elements have already been added by scripts, 
             * the first visible one is selected and the "aria-current" attribute added
             */
            if (this.elements.thumbnails.querySelector('.js-slide-visible button')) {
              this.elements.thumbnails.querySelector('.js-slide-visible button').setAttribute('aria-current', true);
            }
          }
        
          this.setAttribute('data-reset', "false");
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        if (!activeMedia) return;
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        // If the slider is vertical
        if (this.querySelector('slider-component.vertical-slider')) {
          window.setTimeout(() => {
            if (this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
            }
            if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          });
        }

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        /**
         * IMPORTANT
         * If the thumbnail slider is vertical, move the slide showing the active thumbnail
         */
        if (this.elements.viewer.classList.contains('vertical-slider')) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
        }
        else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        //let verticalSlider = document.querySelector('slider-component .thumbnail-list li button[aria-current]').closest('li');
        //verticalSlider.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
